import axios from "axios";

export interface Template {
  id: string | null;
  title: string;
  content: string;
  subject: string;
  predefinedDocuments: string[] | null;
}

interface TemplateApi {
  listTemplates(): Promise<Template[]>;
  addTemplate(template: Template): Promise<string>;
  editTemplate(template: Template): Promise<void>;
  deleteTemplate(template: Template): Promise<void>;
}

export const templateApi: TemplateApi = {
  async listTemplates() {
    return (await axios.get("/api/templates")).data;
  },
  async editTemplate(template) {
    return await axios.put(`/api/templates/${template.id}`, template);
  },
  async addTemplate(template) {
    return (await axios.post("/api/templates", template)).data;
  },
  async deleteTemplate(template) {
    return await axios.delete(`/api/templates/${template.id}`);
  },
};
